(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-visualizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const viewers = document.querySelectorAll('[data-product-visualizer]');
    if (!viewers.length) return;
  
    viewers.forEach((root) => {
      const backgroundSelect = root.querySelector('[data-visualizer-background-select]');
      const fileInput = root.querySelector('[data-visualizer-file-input]');
      const backgroundImage = root.querySelector('[data-visualizer-background]');
      const placeholder = root.querySelector('[data-visualizer-placeholder]');
      const canvasEl = root.querySelector('[data-visualizer-canvas]');
      const horizonEl = root.querySelector('[data-visualizer-horizon]');
      const productImageTemplate = root.querySelector('[data-visualizer-product-template]');
      const productDotTemplate = root.querySelector('[data-visualizer-product-dot-template]');
      const productsContainer = root.querySelector('[data-visualizer-products]');
      const activeProductLabelEl = root.querySelector('[data-visualizer-active-product-label]');
      const addProductButton = root.querySelector('[data-visualizer-products-add]');
      const controlsToggle = root.querySelector('[data-visualizer-controls-toggle]');
      const controlsClose = root.querySelector('[data-visualizer-controls-close]');
      const controlsNav = root.querySelector('.product-visualizer__controls');
      const downloadButtons = root.querySelectorAll('[data-visualizer-download]');
      const helpOpenButtons = root.querySelectorAll('[data-visualizer-help-open]');
      const helpModal = root.querySelector('[data-visualizer-help-modal]');
      const filenameInputs = root.querySelectorAll('[data-visualizer-filename]');
      let customBackgroundUrl = null;
      let horizonFraction = 0.5;
      const HORIZON_HIT_PX = 12;
      let isDraggingHorizon = false;
      let startClientY = 0;
      let startHorizonFraction = 0;
      let isDraggingProduct = false;
      let startClientX = 0;
      let startProductFractionX = 0;
      let startProductFractionY = 0;
      const products = [];
      let activeProduct = null;
      const MAX_EXPORT_DIMENSION = 1080;
      const referenceAreaByPatternKey = {};
      const referenceAreaPreferenceByPatternKey = {};

      const clearButtonActiveState = (button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        button.classList.remove('active', 'is-active');
        requestAnimationFrame(() => {
          button.blur();
        });
      };

      const areaFt2 = (wFt, hFt) => {
        const w = parseFloat(wFt);
        const h = parseFloat(hFt);
        if (!Number.isFinite(w) || !Number.isFinite(h)) return null;
        const area = w * h;
        if (!Number.isFinite(area) || area <= 0) return null;
        return area;
      };

      const parsePatternsJson = (jsonText) => {
        if (!jsonText) return [];
        try {
          const parsed = JSON.parse(jsonText);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.warn('Unable to parse visualizer patterns JSON.', e);
          return [];
        }
      };
  
      if (!backgroundSelect || !fileInput || !backgroundImage || !placeholder) {
        return;
      }

      // Build a global reference area per pattern_key so size scaling stays consistent.
      // Preference: use "*-small" baseline if it exists; otherwise fall back to the first available variant.
      const getVariantSizeFromKey = (variantKey) => {
        const v = String(variantKey || '').toLowerCase();
        if (v.endsWith('-small')) return 'small';
        if (v.endsWith('-large')) return 'large';
        return null;
      };

      const productSelectForReference = root.querySelector('[data-visualizer-product-select]');
      if (productSelectForReference) {
        Array.from(productSelectForReference.options).forEach((opt) => {
          const patternsStr = opt.dataset.visualizerPatterns;
          const patterns = parsePatternsJson(patternsStr);
          patterns.forEach((p) => {
            const patternKey = p.pattern_key;
            const area = areaFt2(p.baseline_width_ft, p.baseline_height_ft);
            if (!patternKey || !area) return;

            const variantSize = getVariantSizeFromKey(p.variant);
            const existingPref = referenceAreaPreferenceByPatternKey[patternKey];

            if (variantSize === 'small') {
              referenceAreaByPatternKey[patternKey] = area;
              referenceAreaPreferenceByPatternKey[patternKey] = 'small';
            } else if (!referenceAreaByPatternKey[patternKey] && variantSize !== 'small') {
              referenceAreaByPatternKey[patternKey] = area;
              referenceAreaPreferenceByPatternKey[patternKey] = variantSize || 'other';
            } else if (existingPref === 'large' && variantSize === 'large' && !referenceAreaByPatternKey[patternKey]) {
              referenceAreaByPatternKey[patternKey] = area;
              referenceAreaPreferenceByPatternKey[patternKey] = 'large';
            }
          });
        });
      }
  
      const applyHorizonPosition = () => {
        if (!horizonEl) return;
        horizonEl.style.top = String(horizonFraction * 100) + '%';
        horizonEl.setAttribute('aria-valuenow', String(Math.round(horizonFraction * 100)));
      };

      // Perspective (like source): scale = 0 only at the horizon, grows with distance from horizon
      const getPerspectiveScale = (product) => {
        const delta = product.fractionY - horizonFraction;
        const strength = 2.5;
        const foregroundMultiplier = 2.25;
        if (delta <= 0) {
          return 0;
        }
        const perspectiveScale = Math.min(3, strength * delta * foregroundMultiplier);

        const patternKey = product.patternKey;
        const actualArea = areaFt2(product.baselineWidthFt, product.baselineHeightFt);
        const referenceArea = patternKey ? referenceAreaByPatternKey[patternKey] : null;

        if (!patternKey || !actualArea || !referenceArea) return perspectiveScale;

        // Use area ratio to derive a linear scale factor (sqrt) for CSS transform scale().
        const sizeScale = Math.sqrt(actualArea / referenceArea);
        return perspectiveScale * sizeScale;
      };

      const applyProductPosition = (product) => {
        const scale = getPerspectiveScale(product);
        if (product.imageEl) {
          product.imageEl.style.left = String(product.fractionX * 100) + '%';
          product.imageEl.style.top = String(product.fractionY * 100) + '%';
          product.imageEl.style.transform = `translate(-50%, -50%) scale(${scale})`;
        }
        if (product.dotEl) {
          product.dotEl.style.left = String(product.fractionX * 100) + '%';
          product.dotEl.style.top = String(product.fractionY * 100) + '%';
          const visible = product.imageEl && product.imageEl.src && product.imageEl.style.display !== 'none';
          product.dotEl.style.display = visible ? '' : 'none';
        }
      };

      const applyAllProductPositions = () => {
        products.forEach((product) => applyProductPosition(product));
      };

      const updateActiveHeading = () => {
        if (!activeProduct || !activeProduct.selectEl || !activeProductLabelEl) {
          if (activeProductLabelEl) {
            activeProductLabelEl.textContent = '';
          }
          return;
        }
        const selectedOption = activeProduct.selectEl.selectedOptions[0];
        const label = selectedOption ? selectedOption.textContent.trim() : '';
        activeProductLabelEl.textContent = label;
      };

      const updateZIndices = () => {
        products.forEach((product) => {
          const isActive = product === activeProduct;
          if (product.imageEl) {
            product.imageEl.style.zIndex = isActive ? '5' : '3';
            product.imageEl.classList.toggle('product-visualizer__product-image--active', isActive);
          }
          if (product.dotEl) {
            product.dotEl.style.zIndex = isActive ? '6' : '4';
            product.dotEl.classList.toggle('product-visualizer__product-dot--active', isActive);
          }
        });
      };

      const setActiveProduct = (product) => {
        if (!product) return;
        if (activeProduct === product) return;

        products.forEach((p) => {
          if (!p.itemEl) return;
          const isTarget = p === product;
          p.itemEl.classList.toggle('is-open', isTarget);
          if (p.toggleButton) {
            p.toggleButton.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
          }
        });

        activeProduct = product;
        updateZIndices();
        updateActiveHeading();
        applyAllProductPositions();
      };
  
      if (canvasEl) {
        if (horizonEl) {
          applyHorizonPosition();
        }
        if (products.length) {
          applyAllProductPositions();
        }
  
        const getClientCoords = (e) => {
          if (e.touches && e.touches[0]) {
            return {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY,
            };
          }
          return {
            x: e.clientX,
            y: e.clientY,
          };
        };
  
        const onPointerDown = (e) => {
          const rect = canvasEl.getBoundingClientRect();
          const { x: clientX, y: clientY } = getClientCoords(e);

          // 1) Product-dot or product-image hit-test across all products (topmost first)
          let hitProduct = null;
          for (let i = products.length - 1; i >= 0; i--) {
            const product = products[i];
            if (product.dotEl && product.dotEl.style.display !== 'none') {
              const dotRect = product.dotEl.getBoundingClientRect();
              if (
                clientX >= dotRect.left &&
                clientX <= dotRect.right &&
                clientY >= dotRect.top &&
                clientY <= dotRect.bottom
              ) {
                hitProduct = product;
                break;
              }
            }
            if (product.imageEl && product.imageEl.src && product.imageEl.style.display !== 'none') {
              const productRect = product.imageEl.getBoundingClientRect();
              if (
                clientX >= productRect.left &&
                clientX <= productRect.right &&
                clientY >= productRect.top &&
                clientY <= productRect.bottom
              ) {
                hitProduct = product;
                break;
              }
            }
          }

          if (hitProduct) {
            e.preventDefault();
            if (hitProduct !== activeProduct) {
              setActiveProduct(hitProduct);
            }
            isDraggingProduct = true;
            startClientX = clientX;
            startClientY = clientY;
            startProductFractionX = hitProduct.fractionX;
            startProductFractionY = hitProduct.fractionY;
            document.addEventListener('mousemove', onPointerMove);
            document.addEventListener('mouseup', onPointerUp);
            document.addEventListener('touchmove', onPointerMove, { passive: false });
            document.addEventListener('touchend', onPointerUp);
            return;
          }

          // 2) Horizon hit-test
          if (horizonEl) {
            const localY = clientY - rect.top;
            const lineY = horizonFraction * rect.height;

            if (Math.abs(localY - lineY) <= HORIZON_HIT_PX) {
              e.preventDefault();
              isDraggingHorizon = true;
              startClientY = clientY;
              startHorizonFraction = horizonFraction;
              canvasEl.classList.add('product-visualizer__canvas--horizon-dragging');

              document.addEventListener('mousemove', onPointerMove);
              document.addEventListener('mouseup', onPointerUp);
              document.addEventListener('touchmove', onPointerMove, { passive: false });
              document.addEventListener('touchend', onPointerUp);
            }
          }
        };
  
        const onPointerMove = (e) => {
          if (!isDraggingHorizon && !isDraggingProduct) return;
          e.preventDefault();

          const rect = canvasEl.getBoundingClientRect();
          const { x: clientX, y: clientY } = getClientCoords(e);

          if (isDraggingProduct) {
            if (!activeProduct) return;
            const deltaX = clientX - startClientX;
            const deltaY = clientY - startClientY;

            activeProduct.fractionX = Math.max(
              0.05,
              Math.min(0.95, startProductFractionX + deltaX / rect.width),
            );
            activeProduct.fractionY = Math.max(
              0.05,
              Math.min(0.95, startProductFractionY + deltaY / rect.height),
            );

            applyProductPosition(activeProduct);
          } else if (isDraggingHorizon) {
            const deltaY = clientY - startClientY;
            horizonFraction = Math.max(
              0,
              Math.min(1, startHorizonFraction + deltaY / rect.height),
            );
            applyHorizonPosition();
            applyAllProductPositions();
          }
        };

        const onPointerUp = () => {
          if (!isDraggingHorizon && !isDraggingProduct) return;

          isDraggingHorizon = false;
          isDraggingProduct = false;
          canvasEl.classList.remove('product-visualizer__canvas--horizon-dragging');

          document.removeEventListener('mousemove', onPointerMove);
          document.removeEventListener('mouseup', onPointerUp);
          document.removeEventListener('touchmove', onPointerMove);
          document.removeEventListener('touchend', onPointerUp);
        };
  
        canvasEl.addEventListener('mousedown', onPointerDown, true);
        canvasEl.addEventListener('touchstart', onPointerDown, { passive: false, capture: true });
      }

      if (controlsToggle) {
        controlsToggle.addEventListener('click', () => {
          root.classList.toggle('product-visualizer--controls-open');
          clearButtonActiveState(controlsToggle);
        });
      }

      if (controlsClose) {
        controlsClose.addEventListener('click', () => {
          root.classList.remove('product-visualizer--controls-open');
          clearButtonActiveState(controlsClose);
        });
      }

      if (helpOpenButtons.length && helpModal) {
        const closeEls = helpModal.querySelectorAll('[data-visualizer-help-close]');

        const openHelp = () => {
          helpModal.classList.add('is-open');
          helpModal.setAttribute('aria-hidden', 'false');
        };

        const closeHelp = () => {
          helpModal.classList.remove('is-open');
          helpModal.setAttribute('aria-hidden', 'true');
        };

        helpOpenButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            openHelp();
            clearButtonActiveState(button);
          });
        });

        closeEls.forEach((el) => {
          el.addEventListener('click', (event) => {
            event.preventDefault();
            closeHelp();
          });
        });
      }

      // Close mobile controls drawer when clicking outside
      if (controlsNav) {
        document.addEventListener('click', (event) => {
          if (!root.classList.contains('product-visualizer--controls-open')) return;

          const target = event.target;
          if (
            controlsNav.contains(target) ||
            (controlsToggle && controlsToggle.contains(target))
          ) {
            return;
          }

          root.classList.remove('product-visualizer--controls-open');
        });
      }
  
      const showPlaceholder = () => {
        backgroundImage.removeAttribute('src');
        backgroundImage.style.display = 'none';
        placeholder.style.display = '';
      };
  
      const showBackground = (url) => {
        if (!url) return;
        backgroundImage.src = url;
        backgroundImage.style.display = 'block';
        placeholder.style.display = 'none';
      };
  
      const updateBackgroundFromPreset = () => {
        const selectedOption = backgroundSelect.selectedOptions[0];
        if (!selectedOption) return;
  
        const value = selectedOption.value;
        if (value === 'custom') {
          showPlaceholder();
          return;
        }
  
        const url = selectedOption.dataset.backgroundUrl || '';
        if (!url) {
          showPlaceholder();
          return;
        }
  
        showBackground(url);
      };
  
      backgroundSelect.addEventListener('change', () => {
        if (backgroundSelect.value === 'custom') {
          if (customBackgroundUrl) {
            showBackground(customBackgroundUrl);
          } else {
            showPlaceholder();
          }
          return;
        }
  
        updateBackgroundFromPreset();
      });
  
      fileInput.addEventListener('change', (event) => {
        const target = event.target;
        const files = target.files;
        if (!files || !files[0]) return;
  
        const file = files[0];
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          if (!result) return;
          customBackgroundUrl = String(result);
          showBackground(customBackgroundUrl);
          backgroundSelect.value = 'custom';
        };
        reader.readAsDataURL(file);
      });
  
      if (backgroundSelect.value === 'custom') {
        showPlaceholder();
      } else {
        updateBackgroundFromPreset();
      }
  
      // --- Product overlay image wiring ---
  
      const createProductElements = () => {
        if (!canvasEl || !productImageTemplate || !productDotTemplate) return null;

        const imageEl = productImageTemplate.cloneNode(true);
        imageEl.removeAttribute('data-visualizer-product-template');
        imageEl.dataset.visualizerProduct = 'true';
        imageEl.style.display = 'none';

        const dotEl = productDotTemplate.cloneNode(true);
        dotEl.removeAttribute('data-visualizer-product-dot-template');
        dotEl.dataset.visualizerProductDot = 'true';
        dotEl.style.display = 'none';

        canvasEl.appendChild(imageEl);
        canvasEl.appendChild(dotEl);

        return { imageEl, dotEl };
      };

      const syncPatternFromSelectedNozzleProduct = (product) => {
        if (!product || !product.selectEl || !product.patternSelectEl) return;
        const nozzleOption = product.selectEl.selectedOptions && product.selectEl.selectedOptions[0];
        if (!nozzleOption) return;

        const patterns = parsePatternsJson(nozzleOption.dataset.visualizerPatterns);

        product.patternSelectEl.innerHTML = '';

        if (!patterns.length) {
          product.patternSelectEl.style.display = 'none';
          if (product.patternFieldEl) product.patternFieldEl.style.display = 'none';
          if (product.patternLabelEl) product.patternLabelEl.style.display = 'none';
          product.imageEl.style.display = 'none';
          product.imageEl.removeAttribute('src');
          product.patternKey = null;
          product.baselineWidthFt = null;
          product.baselineHeightFt = null;
          applyProductPosition(product);
          return;
        }

        // Show the pattern dropdown only when multiple patterns are available.
        const shouldShowPatternSelect = patterns.length > 1;
        product.patternSelectEl.style.display = shouldShowPatternSelect ? '' : 'none';
        if (product.patternFieldEl) {
          product.patternFieldEl.style.display = shouldShowPatternSelect ? '' : 'none';
        }
        if (product.patternLabelEl) {
          product.patternLabelEl.style.display = shouldShowPatternSelect ? '' : 'none';
        }

        patterns.forEach((p) => {
          const option = document.createElement('option');
          option.value = p.image_url || '';
          option.textContent = p.pattern_key || '';
          option.dataset.visualizerPatternKey = p.pattern_key || '';
          option.dataset.visualizerVariant = p.variant || '';
          option.dataset.visualizerBaselineWidthFt = p.baseline_width_ft || '';
          option.dataset.visualizerBaselineHeightFt = p.baseline_height_ft || '';
          product.patternSelectEl.appendChild(option);
        });

        // Default to first available pattern.
        const firstPatternOption = product.patternSelectEl.options[0];
        if (firstPatternOption) {
          product.patternKey = firstPatternOption.dataset.visualizerPatternKey || null;
          product.variant = firstPatternOption.dataset.visualizerVariant || null;
          product.baselineWidthFt = parseFloat(firstPatternOption.dataset.visualizerBaselineWidthFt);
          product.baselineHeightFt = parseFloat(firstPatternOption.dataset.visualizerBaselineHeightFt);

          product.imageEl.src = firstPatternOption.value;
          product.imageEl.style.display = firstPatternOption.value ? 'block' : 'none';
          applyProductPosition(product);

          if (product === activeProduct) {
            updateZIndices();
          }
        }
      };

      const setupProductItem = (itemEl, duplicateOf = null) => {
        if (!itemEl) return null;

        const selectEl = itemEl.querySelector('[data-visualizer-product-select]');
        const patternSelectEl = itemEl.querySelector('[data-visualizer-pattern-select]');
        const patternFieldEl = itemEl.querySelector('[data-visualizer-pattern-field]');
        const patternLabelEl = itemEl.querySelector('[data-visualizer-pattern-label]');
        const panelEl = itemEl.querySelector('[data-visualizer-product-panel]');
        const toggleButton = itemEl.querySelector('[data-visualizer-product-toggle]');
        const titleEl = itemEl.querySelector('[data-visualizer-product-title]');

        const elements = createProductElements();
        if (!elements) return null;

        const product = {
          itemEl,
          selectEl,
          patternSelectEl,
          patternFieldEl,
          patternLabelEl,
          panelEl,
          toggleButton,
          titleEl,
          imageEl: elements.imageEl,
          dotEl: elements.dotEl,
          fractionX: duplicateOf ? duplicateOf.fractionX : 0.5,
          fractionY: duplicateOf ? duplicateOf.fractionY : (horizonFraction + 0.95) / 2,
          patternKey: null,
          variant: null,
          baselineWidthFt: null,
          baselineHeightFt: null,
        };

        if (duplicateOf && duplicateOf.imageEl && duplicateOf.imageEl.src) {
          product.imageEl.src = duplicateOf.imageEl.src;
          product.imageEl.style.display = duplicateOf.imageEl.style.display;
        }

        if (selectEl) {
          if (duplicateOf && duplicateOf.selectEl && duplicateOf.selectEl.value) {
            selectEl.value = duplicateOf.selectEl.value;
          }
          const selectedOption = selectEl.selectedOptions[0];
          if (titleEl && selectedOption) {
            titleEl.textContent = selectedOption.textContent.trim();
          }
        }

        if (toggleButton) {
          toggleButton.addEventListener('click', () => {
            setActiveProduct(product);
            clearButtonActiveState(toggleButton);
          });
        }

        if (patternSelectEl) {
          patternSelectEl.addEventListener('change', () => {
            const selectedOption = patternSelectEl.selectedOptions && patternSelectEl.selectedOptions[0];
            if (!selectedOption) return;

            product.patternKey = selectedOption.dataset.visualizerPatternKey || null;
            product.variant = selectedOption.dataset.visualizerVariant || null;
            product.baselineWidthFt = parseFloat(selectedOption.dataset.visualizerBaselineWidthFt);
            product.baselineHeightFt = parseFloat(selectedOption.dataset.visualizerBaselineHeightFt);

            const url = selectedOption.value;
            if (url) {
              product.imageEl.src = url;
              product.imageEl.style.display = 'block';
            } else {
              product.imageEl.removeAttribute('src');
              product.imageEl.style.display = 'none';
            }

            applyProductPosition(product);
            if (product === activeProduct) {
              updateZIndices();
            }
          });
        }

        applyProductPosition(product);
        products.push(product);
        updateRemoveButtonsState();
        return product;
      };

      const updateRemoveButtonsState = () => {
        if (!productsContainer) return;
        const shouldDisableRemove = products.length <= 1;
        const removeButtons = productsContainer.querySelectorAll('[data-visualizer-product-remove]');
        removeButtons.forEach((button) => {
          if (!(button instanceof HTMLButtonElement)) return;
          button.disabled = shouldDisableRemove;
          button.setAttribute('aria-disabled', shouldDisableRemove ? 'true' : 'false');
        });
      };

      const removeProduct = (product) => {
        if (products.length <= 1) return false;
        const index = products.indexOf(product);
        if (index === -1) return false;

        products.splice(index, 1);

        if (product.imageEl && product.imageEl.parentElement) {
          product.imageEl.parentElement.removeChild(product.imageEl);
        }
        if (product.dotEl && product.dotEl.parentElement) {
          product.dotEl.parentElement.removeChild(product.dotEl);
        }
        if (product.itemEl && product.itemEl.parentElement) {
          product.itemEl.parentElement.removeChild(product.itemEl);
        }

        if (activeProduct === product) {
          activeProduct = null;
          if (products.length > 0) {
            setActiveProduct(products[0]);
          } else if (activeProductLabelEl) {
            activeProductLabelEl.textContent = '';
          }
        } else {
          updateZIndices();
          updateActiveHeading();
        }
        updateRemoveButtonsState();
        return true;
      };

      if (productsContainer && canvasEl && productImageTemplate && productDotTemplate) {
        const initialItems = Array.from(
          productsContainer.querySelectorAll('[data-visualizer-product-item]')
        );

        initialItems.forEach((itemEl) => {
          const product = setupProductItem(itemEl);
          if (product) {
            syncPatternFromSelectedNozzleProduct(product);
          }
        });

        if (products.length && !activeProduct) {
          setActiveProduct(products[0]);
        }
        updateRemoveButtonsState();

        productsContainer.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof HTMLSelectElement)) return;
          if (!target.matches('[data-visualizer-product-select]')) return;

          const product = products.find((p) => p.selectEl === target);
          if (!product) return;

          syncPatternFromSelectedNozzleProduct(product);

          if (product.titleEl) {
            const selectedOption = target.selectedOptions[0];
            product.titleEl.textContent = selectedOption ? selectedOption.textContent.trim() : '';
          }
          if (product === activeProduct) {
            updateActiveHeading();
          }
        });

        productsContainer.addEventListener('click', (event) => {
          const target = event.target.closest('button');
          if (!target) return;

          if (target.hasAttribute('data-visualizer-product-duplicate')) {
            event.preventDefault();
            const itemEl = target.closest('[data-visualizer-product-item]');
            if (!itemEl) return;
            const sourceProduct = products.find((p) => p.itemEl === itemEl);
            if (!sourceProduct) return;

            const clonedItem = itemEl.cloneNode(true);
            const clonedButtons = clonedItem.querySelectorAll('button');
            clonedButtons.forEach((button) => {
              button.classList.remove('active', 'is-active');
              button.blur();
            });
            const clonedButtonFills = clonedItem.querySelectorAll('[data-fill]');
            clonedButtonFills.forEach((fill) => {
              if (!(fill instanceof HTMLElement)) return;
              fill.style.removeProperty('--motion-translateY');
              fill.style.removeProperty('transform');
              if (!fill.getAttribute('style')?.trim()) {
                fill.removeAttribute('style');
              }
            });
            itemEl.after(clonedItem);
            const newProduct = setupProductItem(clonedItem, sourceProduct);
            if (newProduct) {
              syncPatternFromSelectedNozzleProduct(newProduct);
              setActiveProduct(newProduct);
            }
            clearButtonActiveState(target);
          }

          if (target.hasAttribute('data-visualizer-product-remove')) {
            event.preventDefault();
            const itemEl = target.closest('[data-visualizer-product-item]');
            if (!itemEl) return;
            const product = products.find((p) => p.itemEl === itemEl);
            if (!product) return;

            removeProduct(product);
            clearButtonActiveState(target);
          }
        });
      }

      if (addProductButton && productsContainer && canvasEl && productImageTemplate && productDotTemplate) {
        addProductButton.addEventListener('click', (event) => {
          event.preventDefault();

          let templateItem = productsContainer.querySelector('[data-visualizer-product-item]');
          if (!templateItem) return;

          const newItem = templateItem.cloneNode(true);
          // Reset select to first option
          const selectEl = newItem.querySelector('[data-visualizer-product-select]');
          if (selectEl && selectEl.options.length > 0) {
            selectEl.selectedIndex = 0;
          }

          // Reset title label; it will be updated on first change
          const titleEl = newItem.querySelector('[data-visualizer-product-title]');
          if (titleEl && selectEl && selectEl.selectedOptions[0]) {
            titleEl.textContent = selectEl.selectedOptions[0].textContent.trim();
          }

          const addButtonWrapper = addProductButton.closest('.product-visualizer__products-add');
          if (addButtonWrapper && addButtonWrapper.parentElement === productsContainer) {
            productsContainer.insertBefore(newItem, addButtonWrapper);
          } else {
            productsContainer.appendChild(newItem);
          }
          const newProduct = setupProductItem(newItem);
          if (newProduct) {
            syncPatternFromSelectedNozzleProduct(newProduct);
            setActiveProduct(newProduct);
          }
          clearButtonActiveState(addProductButton);
        });
      }

      const exportSnapshot = () => {
        if (!canvasEl || !backgroundImage) return;

        if (!backgroundImage.src) {
          alert('Please choose a background image before downloading a snapshot.');
          return;
        }

        const runExport = () => {
          const baseWidth = backgroundImage.naturalWidth || canvasEl.clientWidth || 1600;
          const baseHeight = backgroundImage.naturalHeight || canvasEl.clientHeight || 900;

          const maxSide = Math.max(baseWidth, baseHeight);
          const scale = maxSide > MAX_EXPORT_DIMENSION
            ? MAX_EXPORT_DIMENSION / maxSide
            : 1;

          const exportWidth = Math.round(baseWidth * scale);
          const exportHeight = Math.round(baseHeight * scale);

          const exportCanvas = document.createElement('canvas');
          exportCanvas.width = exportWidth;
          exportCanvas.height = exportHeight;

          const ctx = exportCanvas.getContext('2d');
          if (!ctx) return;

          // Draw background scaled to export canvas
          try {
            ctx.drawImage(backgroundImage, 0, 0, exportWidth, exportHeight);
          } catch (e) {
            console.error('Unable to draw background image to export canvas.', e);
            return;
          }

          if (products.length && canvasEl.getBoundingClientRect) {
            const canvasRect = canvasEl.getBoundingClientRect();
            const canvasWidth = canvasRect.width || 1;
            const canvasHeight = canvasRect.height || 1;

            products.forEach((product) => {
              const imgEl = product.imageEl;
              if (!imgEl || !imgEl.src || imgEl.style.display === 'none') {
                return;
              }

              const imgRect = imgEl.getBoundingClientRect();

              const centerXFrac = ((imgRect.left + imgRect.width / 2) - canvasRect.left) / canvasWidth;
              const centerYFrac = ((imgRect.top + imgRect.height / 2) - canvasRect.top) / canvasHeight;
              const widthFrac = imgRect.width / canvasWidth;
              const heightFrac = imgRect.height / canvasHeight;

              const destWidth = widthFrac * exportWidth;
              const destHeight = heightFrac * exportHeight;
              const destX = centerXFrac * exportWidth - destWidth / 2;
              const destY = centerYFrac * exportHeight - destHeight / 2;

              try {
                ctx.drawImage(imgEl, destX, destY, destWidth, destHeight);
              } catch (e) {
                console.warn('Unable to draw product image to export canvas.', e);
              }
            });
          }

          const downloadFromCanvas = () => {
            let baseName = 'KascoSnapshot';
            if (filenameInputs && filenameInputs.length) {
              const firstWithValue = Array.from(filenameInputs).find((input) => {
                return input.value && input.value.trim().length > 0;
              });
              if (firstWithValue) {
                baseName = firstWithValue.value.trim();
              }
            }

            const safeName = baseName.replace(/[/\\?%*:|"<>]/g, '').trim() || 'KascoSnapshot';
            const filename = safeName.endsWith('.png') ? safeName : `${safeName}.png`;

            if (exportCanvas.toBlob) {
              exportCanvas.toBlob((blob) => {
                if (!blob) return;
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
              }, 'image/png');
            } else {
              const dataUrl = exportCanvas.toDataURL('image/png');
              const link = document.createElement('a');
              link.href = dataUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          };

          downloadFromCanvas();
        };

        if (backgroundImage.complete && backgroundImage.naturalWidth) {
          runExport();
        } else {
          const onLoad = () => {
            backgroundImage.removeEventListener('load', onLoad);
            runExport();
          };
          backgroundImage.addEventListener('load', onLoad);
        }
      };

      if (downloadButtons && downloadButtons.length) {
        downloadButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            exportSnapshot();
            clearButtonActiveState(button);
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
